import { Operation, OperationCreate, OperationPayloadSwitchPage, OperationType } from '@ekkogmbh/apisdk';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import { PureComponent } from 'react';
import { spacing } from 'src/Common/Helper/ThemeHelper';

const OperationTypeTexts: Record<OperationType, string> = {
  'switch-page': 'Switch-Page',
  'compartment-update': 'Compartment-Update',
};

interface OperationCardProps {
  operation: Operation | OperationCreate;
}

export class OperationCard extends PureComponent<OperationCardProps> {
  public render(): React.JSX.Element {
    const {
      operation: { type },
    } = this.props;

    return (
      <Card elevation={4} sx={{ backgroundColor: (theme) => theme.palette.primary.light }}>
        <CardContent sx={{ padding: (theme) => spacing(theme) }}>
          <CardHeader sx={{ padding: (theme) => spacing(theme) }} title={OperationTypeTexts[type]} />
          {this.renderOperationTypeInfo()}
        </CardContent>
      </Card>
    );
  }

  private renderOperationTypeInfo = () => {
    const { operation } = this.props;
    const { type, payload } = operation;

    switch (type) {
      case OperationType.SWITCH_PAGE:
      default:
        const switchPagePayload = payload as OperationPayloadSwitchPage;

        return (
          <Typography
            variant={'body2'}
            component={'h2'}
            align={'left'}
            sx={{ color: (theme) => theme.palette.secondary.light, fontWeight: 700 }}
          >
            <ul>
              <li>{'Label-Id: ' + switchPagePayload.labelId}</li>
              <li>{'Technology: ' + switchPagePayload.technology}</li>
              <li>{'Page-Number: ' + switchPagePayload.pageNumber}</li>
            </ul>
          </Typography>
        );
    }
  };
}
